import { FC } from "react";
import { Link } from "react-router-dom";

import ImageCommon from "web/Layout/Common/Image";
import __ from "web/Layout/Translations";

import styles from "./image.scss";

interface IImageProps {
  link: string;
  name: string;
  image: string;
}

const Image: FC<IImageProps> = ({ link, name, image }) => {
  return (
    <Link
      to={link}
      className={styles.root}
      aria-label={
        link?.includes("orders")
          ? `${__("Przejdź do szczegółów zamówienia")}: ${name}`
          : `${__("Przejdź do strony produktu")}: ${name}`
      }
    >
      <ImageCommon className={styles.image} src={image} alt="" isProduct />
    </Link>
  );
};

export default Image;
